import React, {Fragment} from 'react';
import { Link } from 'react-router-dom'
import Header from '../../../Components/Modules/Includes/Header'
import MdArrowBack from 'react-icons/lib/md/arrow-back'
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton'
import Checkbox from 'material-ui/Checkbox'
import { Row, Col, PanelGroup, Panel } from 'react-bootstrap'
import RaisedButton from 'material-ui/RaisedButton'
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton'
import MdDelete from 'react-icons/lib/md/delete'
import MdCloudDownload from 'react-icons/lib/md/cloud-download'
import MdPermContactCalendar from 'react-icons/lib/md/perm-contact-calendar'
import MdDateRange from 'react-icons/lib/md/date-range'
import DatePicker from 'material-ui/DatePicker';
import moment from 'moment';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Route, withRouter } from 'react-router-dom';
import * as actions from '../../../Actions/';
import AdminJobDetail from './AdminJobDetail';
import Moment from 'react-moment';
import Modal from 'react-modal';
import Dialog from 'material-ui/Dialog';
import LinearProgress from 'material-ui/LinearProgress';
import TiTick from 'react-icons/lib/ti/tick'
import CompanySignupStep from '../../Modules/CompanySignupStep'
import CancelDokkit from '../../Modules/CancelDokkit'
import Paginate from '../../../Components/Modules/Helper/Paginate'

Modal.setAppElement('#root')
const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		width: '500px',
		transform: 'translate(-50%, -50%)'
	}
};
class AdminCompany extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			jobSearchText: '',
			modalIsOpen: false,
			templatetitle: '',
			templateid: '',
			manualid: '',
			modalIsOpenDeleteTemp: false,
			deleteTempCompId: '',
			deleteTempGroupName: '',
			trailEndDate: null,
			allowance: '',
			allowanceUpdate: false,
			allowanceError: false,
			readonlydatepicker: true,
			jobSortByIdDirection: false,
			jobSortBySiteDirection: false,
			jobSortByStatusDirection: false,
			jobSortByImportDirection: true,
			jobSortBy: 'importedat',
			companyid: '',
			tmpSetId: '',
			activeKey: 0,
			modalForceReAuthorise: {
				isOpen : false,
				requesting : false,
			},
			activePage:1
		};
		this.jobSearchTextChange = this.jobSearchTextChange.bind(this);
		this.jobSortBy = this.jobSortBy.bind(this);
		this.openJob = this.openJob.bind(this);
		this.closeModal = this.closeModal.bind(this);
		this.openModal1 = this.openModal1.bind(this);
		this.registerFileToUpload = this.registerFileToUpload.bind(this);
		this.uploadTemplateFile = this.uploadTemplateFile.bind(this);
		this.stopFormSubmit = this.stopFormSubmit.bind(this);
		this.closeModalDeleteTemp = this.closeModalDeleteTemp.bind(this);
	}
	openModalDeleteTemp(companyid, groupName, tmpSetId) {
		this.setState({ 
			modalIsOpenDeleteTemp: true, 
			deleteTempCompId: companyid, 
			deleteTempGroupName: groupName, 
			tmpSetId 
		});
	}
	closeModalDeleteTemp() {
		this.setState({ modalIsOpenDeleteTemp: false });
	}
	openJob(job) {
		this.props.history.push(`/admin-job/${job.simpro_id}`);
	}

	calculateTrailDays = (id, subscriptionhistory) => {
		var trailEnd1, trail_start_date1;
		let subs_history = this.props.subscriptionhistory || subscriptionhistory;
		if (subs_history !== null) {
			let subs_history1 = _.filter(subs_history, { 'company_id': this.state.companyid });
			if (subs_history1.length > 1) {
				this.setState({ readonlydatepicker: true })
			} else {
				if (subs_history1 && subs_history1.length !== 0) {
					this.setState({ readonlydatepicker: false })
				}
			}
		}
	}
	jobSortBy(sortby) {
		switch (sortby) {
			case 'jobid':
				this.setState({ jobSortBy: sortby, jobSortByIdDirection: !this.state.jobSortByIdDirection });
				break;
			case 'site':
				this.setState({ jobSortBy: sortby, jobSortBySiteDirection: !this.state.jobSortBySiteDirection });
				break;
			case 'status':
				this.setState({ jobSortBy: sortby, jobSortByStatusDirection: !this.state.jobSortByStatusDirection });
				break;
			case 'importedat':
				this.setState({ jobSortBy: sortby, jobSortByImportDirection: !this.state.jobSortByImportDirection });
				break;
			//default : 

		}
	}
	componentDidMount() {
		let urlstring = window.location;
		let getid = urlstring.toString().split('/');
		let companyid = '';
		if (getid[getid.length - 1]) {
			companyid = getid[getid.length - 1];
			this.setState({ companyid: companyid });
		}
		if (companyid) {
			this.props.fetchManuals(companyid);
			this.props.getSubscriptionhistoryData(companyid);
			this.props.getTemplateSet(companyid, "details");
		}
		this.calculateTrailDays(companyid);

		const force_reauthorised = window.localStorage.getItem('force_reauthorised');
		window.localStorage.removeItem('force_reauthorised');
		if(force_reauthorised === companyid){
			this.props._forceAuthoriseDone();
		}
	}
	componentWillReceiveProps(newProps) {
		if (newProps.subscriptionhistory && newProps.subscriptionhistory.length > 0) {
			let urlstring = window.location;
			let getid = urlstring.toString().split('/');
			let companyid = '';
			this.calculateTrailDays(companyid, newProps.subscriptionhistory);
		}
		let check = newProps.manuals.manualRemovedByAdmin;
		if (check) {
			this.props.fetchLoginUserDetail();
			this.props.resetManualRemovedFlag();
		}
	}
	stopFormSubmit(e) {
		e.preventDefault();

	}
	openModal1(e) {
		this.setState({ modalIsOpen: true, templatetitle: e.title, templateid: e._id, manualid: e.manual });
	}
	closeModal() {
		this.setState({ modalIsOpen: false });
	}
	registerFileToUpload(e) {
		const files = [...e.target.files];
		this.setState({
			uploadFiles: files
		});
	}
	// template upload for a company
	uploadTemplateFile(companyid, manual_id, template_id) {
		if (this.state.uploadFiles) {
			this.props.uploadTemplateFile(manual_id, template_id, companyid, this.state.uploadFiles)
				.then(() => {
					if (this.filesInput) {
						this.filesInput.value = '';
					}
					
					window.location.reload();
				});
			/*window.setTimeout(() => {
			  if(this.filesInput){
				this.filesInput.value = '';
			  }
			  window.location.reload();
			}, 3000);*/
		}
	}
	jobSearchTextChange(id,event) {
		this.setState({ jobSearchText: event.target.value },()=>{
			this.props.searchJob(this.state.jobSearchText,id)
		});
	}
	trailEndDate = (e, date) => {
		this.setState({ trailEndDate: date })
	}
	changeAllowance = (e) => {
		const allowance = e.target.value;
		this.setState({ allowanceUpdate: true, allowance: allowance })
	}
	updateDetail = (id) => {
		const trailend = this.state.trailEndDate === null && this.props.subscriptionhistory ? this.props.subscriptionhistory.end_date : this.state.trailEndDate;
		let allow = document.getElementById("allowance").value;
		let update_subs_data = this.props.subscriptionsReducer ? this.props.subscriptionsReducer.newSubsData : null;
		var allowChanges = 0;

		if (allow === '') {
			this.setState({ allowanceError: true })
			return false;
		}
		else {
			allowChanges = allow - update_subs_data[0].allowance;
			this.setState({ allowanceError: false })
			const trail_end1 = new Date(trailend);
			this.props.extendFreetrial(trail_end1, allow, id, allowChanges).then(res => {
				this.props.getSubscriptionhistoryData(id);
			});;
		}
	}
	handlePageChange = (pageNumber)=> {
	
		let urlstring = window.location;
		let getid = urlstring.toString().split('/');
		let id = '';
		if (getid[getid.length - 1]) {
			id = getid[getid.length - 1];
		}
		this.setState({activePage: pageNumber},()=>{	
			if(this.state.jobSearchText){
				this.props.searchJob(this.state.jobSearchText,id,this.state.activePage)
			}else{
				this.props.getSubscriptionhistoryData(id,this.state.activePage);
			}
		});
	}
	// job listing
	renderJobs(compId) {
		let alljobs = this.props.alljobs;
		let companyjobs = this.props.companyjobs;
		// console.log("company_jobs", companyjobs)
		let jobsOfCompany = _.filter(companyjobs, { 'company_id': compId });

		var jobs = [];
		jobs = _.filter(alljobs,{ 'company_id': compId })
		// console.log("company jobs", jobs);
		// _.forEach(jobsOfCompany, function (companyjob) {
		// 	let job = _.filter(alljobs, { 'simpro_id': parseInt(companyjob.job_id) });
		// 	if (job) {
		// 		jobs.push(job[0]);
		// 	}
		// })
		// if (this.state.jobSearchText) {
		// 	jobs = _.filter(jobs, (job) => {
		// 		if (job.simpro_id.toString().indexOf(this.state.jobSearchText) !== -1) {
		// 			return true;
		// 		}
		// 		return false;
		// 	});
		// }

		if (this.state.jobSortBy) {
			let filterBy = this.state.jobSortBy;
			switch (filterBy) {
				case 'jobid':
					jobs.sort((a, b) => {
						return this.state.jobSortByIdDirection ? b.simpro_id - a.simpro_id : a.simpro_id - b.simpro_id;
					});
					break;
				case 'site':
					jobs = _.sortBy(jobs, [function (o) { return o.simpro_job.Site.SiteName; }]);
					if (this.state.jobSortBySiteDirection === false) {
						jobs = jobs.reverse();
					}
					break;
				case 'status':
					jobs = _.sortBy(jobs, [function (o) { return o.status; }]);
					if (this.state.jobSortByStatusDirection === false) {
						jobs = jobs.reverse();
					}
					break;
				case 'importedat':
					jobs.sort((a, b) => {
						return this.state.jobSortByImportDirection ? new Date(b.imported_at) - new Date(a.imported_at) : new Date(a.imported_at) - new Date(b.imported_at);
					});
					//jobs = _.sortBy(jobs, [function(o) { return o.imported_at; }]);
					break;
				default:
					jobs.sort((a, b) => {
						return this.state.jobSortByImportDirection ? new Date(b.imported_at) - new Date(a.imported_at) : new Date(a.imported_at) - new Date(b.imported_at);
					});
					//jobs = _.sortBy(jobs, [function(o) { return o.imported_at; }]);
					break;
			}
		}

		if (jobs.length != 0) {
			return jobs.map((j, i) => {
				// console.log("here i am", j)
				let siteName = _.has(j, 'simpro_job.Site.SiteName') ? j.simpro_job.Site.SiteName : '';
				//var now = new Date(j.imported_at);
				if(j){
					return (
						<tr key={`job${j.simpro_id}`} onClick={() => { this.openJob(j); }}>
							<td data-title="Job Id">{j.simpro_id}</td>
							<td data-title="Site">{siteName}</td>
							<td data-title="Status">{j.status}</td>
							<td data-title="Inported at">
								<Moment format=" MMM-DD-YYYY , hh:mm a">
									{j.imported_at}
								</Moment>
							</td>
							<td className="last-child" data-title="Sent to simPRO">
								<input type="checkbox" value="" defaultChecked={j.sent_to_simpro ? true : false} className="checkboxs" />
								<span></span>
							</td>
							<td data-title="Manaual Created">
								<input type="checkbox" value="" defaultChecked={j.pdf_created_at ? true : false} className="checkboxs" />
								<span></span>
							</td>
						</tr>
					);
				}
				
			});
		} else {
			return (
				<tr>
					<td colSpan="6"><p className="no-data-table">No any jobs founds.</p></td>
				</tr>
			);
		}
	}
	removeCompanyTemplate() {
		this.closeModalDeleteTemp();
		let compId = this.state.deleteTempCompId;
		let groupName = this.state.deleteTempGroupName;
		let tmpSetId = this.state.tmpSetId;
		this.props.removeCompanyTemplate(compId, groupName, tmpSetId);
	}
	renderGroupedItems(companyDetail, templateSet) {

		let templates = {...this.props.templates}
		let template_items = templates.items || []

		const groupItems = _.filter(template_items, function(o) {
		    return _.indexOf(templateSet.templates, o._id) > -1;
		});

		// let selectedManuals = companyDetail[0] && _.keys(companyDetail[0].selectedManuals);

		let selectedManuals = _.keys(templateSet.selectedManuals);

		let compId = companyDetail[0] && companyDetail[0].company_id;
		let groupedItems;
		let groups = _.groupBy(groupItems, 'category');

		groupedItems = _.map(groups, (group, groupName) => {
			let check = _.indexOf(selectedManuals, groupName);
			if (check !== -1) {
				let items = group.map((t, i) => {
					var lastupdated;
					if (t.lastUpdated) {
						var now = new Date(t.lastUpdated);
						lastupdated = now;
					}

					return (
						<tr key={`template-${t.title}-${i}`}>
							<td width="30%">{t.title}</td>
							<td width="40%">
								Updated :
              {lastupdated ?
									<Moment format=" MMM-DD-YYYY">
										{lastupdated}
									</Moment>
									: ''}
							</td>
							<td width="15%">
								{t.download ?
									<a target="_blank" href={t.download}><i className="zmdi zmdi-download"></i> Download</a>
									:
									'No Templates to download'
								}
							</td>
							<td width="15%">
								<div className="upload-file-sec">
									<label htmlFor="input-file-down" onClick={(e) => { this.openModal1(t, e) }}>
										<i className="zmdi zmdi-upload"></i> Upload
                </label>
								</div>
							</td>
						</tr>
					);
				});
				let groupNameText = '';
				let iconClass = '';
				switch (groupName) {
					case 'COVER':
						groupNameText = 'Title Cover Sheet ';
						iconClass = 'zmdi zmdi-file-text';
						break;
					case 'AUDIO_VISUAL':
						groupNameText = 'Audio Visual';
						iconClass = 'zmdi zmdi-volume-up';
						break;
					case 'OTHER_WORKS':
						groupNameText = 'Other Works';
						iconClass = 'zmdi zmdi-case';
						break;
					case 'ELECTRICAL':
						groupNameText = 'Electrical';
						iconClass = 'zmdi zmdi-input-power';
						break;
					case 'FIRE_DETECTION':
						groupNameText = 'Fire Detection';
						iconClass = 'zmdi zmdi-fire';
						break;
					case 'MECHANICAL':
						groupNameText = 'Mechanical';
						iconClass = 'zmdi zmdi-wrench';
						break;
					case 'SECURITY':
						groupNameText = 'Security';
						iconClass = 'zmdi zmdi-shield-security';
						break;
					case 'VOICE_DATA':
						groupNameText = 'Voice Data'
						iconClass = 'zmdi zmdi-phone-in-talk';
						break;
					case 'FLOORING':
						groupNameText = 'Flooring';
						iconClass = 'zmdi zmdi-grid';
						break;
					case 'ROOFING':
						groupNameText = 'Roofing';
						iconClass = 'zmdi zmdi-balance';
						break;
					case 'HVAC':
						groupNameText = 'HVAC'
						iconClass = 'zmdi zmdi-toys';
						break;
					case 'RENEWABLES':
						groupNameText = 'Renewables'
						iconClass = 'zmdi zmdi-refresh';
						break;
					default:
						break;
				}
				return (
					<Panel key={`${groupName}`} eventKey={`template-group-${groupName}`}>
						<Panel.Heading>
							<Panel.Title toggle><i className={iconClass}></i> {groupNameText} </Panel.Title>
							{groupName !== 'COVER' ? <a className="trash-tech-file" onClick={(e) => { this.openModalDeleteTemp(compId, groupName, templateSet._id) }}><MdDelete color="#e94731" /></a> : null}
						</Panel.Heading>
						<Panel.Body collapsible >
							<div className="dashboard-table-data">
								<table width="100%">
									<tbody>
										{items}
									</tbody>
								</table>
							</div>
						</Panel.Body>
					</Panel>
				);
			}
		});
		return groupedItems;
	}

	_onTitleClick = (activeKey) => {
		this.setState({
			activeKey : activeKey === this.state.activeKey ? null : activeKey
		})
	}



	_openForceAuthoriseModal = () => {
		this.setState({
			modalForceReAuthorise : {...this.state.modalForceReAuthorise, isOpen: true}
		})
	}

	_closeForceAuthoriseModal = () => {
		this.setState({
			modalForceReAuthorise : {...this.state.modalForceReAuthorise, isOpen: false}
		})
	}

	_doForceAuthorise = () => {

		let companyId = this._getCompanyParamId();
		const { companies } = this.props;
		let companyInfo = _.find(companies, { '_id': companyId });

		let url = companyInfo.simpro_url || ""
		let simprouser = companyInfo.simprouser  || ""
		let simpropass = companyInfo.simpropass || ""

		if(url && simprouser && simpropass){
			this.setState({
				modalForceReAuthorise : {...this.state.modalForceReAuthorise, requesting: true}
			}, () => {
				this.props.authorizeApi(companyId, url, simprouser, simpropass, false, `admin-company/${companyId}`);
			})
		}else{
			alert("Invalid sympro details")
		}
		
	}

	_getCompanyParamId  = () => {
		let urlstring = window.location;
		let getid = urlstring.toString().split('/');
		let id = '';
		if (getid[getid.length - 1]) {
			id = getid[getid.length - 1];
		}
		return id;
	}

	render() {
		
		let { templates: { isUploadingFile } } = this.props;
		let id = this._getCompanyParamId();

		let companydetails = this.props.companydetails;
		let companies = this.props.companies;
		let company = _.filter(companies, { '_id': id });
		let filterCompanyDetail = _.filter(companydetails, { 'company_id': id });
		var state, city, postcode, addressline2, addressline1, country, companyname;
		let subscriptionhistory = this.props.subscriptionhistory;
		let update_subs_data = this.props.subscriptionsReducer ? this.props.subscriptionsReducer.newSubsData : null;

		if (companydetails !== null) {
			let companydetail = _.filter(companydetails, { 'company_id': id });
			let companyid = companydetail[0] ? companydetail[0].company_id : '-';
			companyname = _.filter(companies, { '_id': companyid })[0].name;
			postcode = companydetail[0].address ? companydetail[0].address.postcode : '-'
			state = companydetail[0].address ? companydetail[0].address.state : '-';
			city = companydetail[0].address ? companydetail[0].address.city : '-';
			addressline1 = companydetail[0].address ? companydetail[0].address.addressline1 : '-';
			addressline2 = companydetail[0].address ? companydetail[0].address.addressline2 : '-';
			country = companydetail[0].address ? companydetail[0].address.country : '-';
		}
		var trailEnd, allowance, trail_start_date;
		if (subscriptionhistory !== null) {
			let subs_history = _.filter(subscriptionhistory, { 'company_id': id });
			let sortInReverse = _.sortBy(subs_history).reverse();
			if (subs_history.length > 1) {
				trailEnd = subs_history[0] ? subs_history[0].end_date : null;
			} else {
				trailEnd = update_subs_data && update_subs_data[0] ? update_subs_data[0].end_date : null
			}
			// trailEnd = subs_history[0] ? subs_history[0].end_date: null;
			trail_start_date = subs_history[0] ? subs_history[0].start_date : null;
			// allowance = sortInReverse[0] ? sortInReverse[0].allowance: null;
		}
		let subscriptions = this.props.subscriptions;
		let subsdetails = this.props.subsusers;
		var planName, billing;
		let companyUserId = null
		if (subsdetails !== null && subscriptions != null) {
			let subsdetail = _.filter(subsdetails, { 'company_id': id });
			planName = _.filter(subscriptions, { '_id': subsdetail[0].subscription_id })[0].label;
			billing = _.filter(subscriptions, { '_id': subsdetail[0].subscription_id })[0].duration_type;
			companyUserId = subsdetail[0].user_id
		}
		let companyUser = this.props.allusers
		var companyEmail;
		
		if (companyUser !== null && subsdetails !== null) {
			let subsdetail1 = _.filter(subsdetails, { 'company_id': id });
			let userId = subsdetail1[0].user_id;
			let user = _.filter(companyUser, { '_id': userId })
			companyEmail = user[0].email;
			
		}
		let job = this.renderJobs(id);


		let groupedItems = [];
		if (this.props.templates && this.props.templates.items && this.props.templates.items.length > 0) {

			this.props.companyTemplateSet.map((set, i) => {

				let items = this.renderGroupedItems(filterCompanyDetail, set);

				groupedItems.push(
					<Panel eventKey={i} key={`panel_${i}`}>
			          	<Panel.Heading>
			            	<Panel.Title toggle onClick={() => {
				      			this._onTitleClick(i)
				      		}} >{set.template_set_name}</Panel.Title>
			          	</Panel.Heading>
			          	<Panel.Body collapsible>
			          		<PanelGroup accordion id="accordion-example">
								{items}
							</PanelGroup>
			          	</Panel.Body>
			        </Panel>
				)	
			})

		}

		let manual_id = this.state.manualid;
		let template_id = this.state.templateid;
		const uploadLabel = isUploadingFile ? 'Uploading...' : 'Upload File';
		const trailEndDate1 = new Date(trailEnd);
		let today = new Date();

		const action = [
			<FlatButton
				label="Cancel"
				primary={true}
				onClick={this.closeModalDeleteTemp}
			/>,
			<RaisedButton
				label="Yes"
				primary={true}
				labelStyle={{ 'color': '#fff' }}
				keyboardFocused={true}
				onClick={(e) => { this.removeCompanyTemplate() }}
			/>
		];


		const companyInfo = company[0] || null
		return (
			<div>
				<Header />
				<Route path={`${this.props.match.url}/:jobId`} component={AdminJobDetail} />
				<div className="dashboard-page">
					<div className="right-content-dashboard active-dashboard">
						<div className="dashboard-content-sec table-dashboard audio-visual-content admin-company backgoud-color">
							<div className="top-heading">
								<div className="back-button-heading">
									<h2><Link to="/admin-dashboard"><MdArrowBack /></Link>{companyname}</h2>
								</div>
							</div>

							<CompanySignupStep step_completed = {companyInfo ? companyInfo.step_completed : 0}/>


							<div className="dashboard-table-data">
								<div className="audio-visual-list">
									<h3>Address Details</h3>
									<table className="dashboard-table">
										<tbody>
											<tr>
												<td width="50%">Address Line 1 </td>
												<td width="50%">{addressline1}</td>
											</tr>
											<tr>
												<td width="50%">Address Line 2 </td>
												<td width="50%">{addressline2}</td>
											</tr>
											<tr>
												<td width="50%">City </td>
												<td width="50%">{city}</td>
											</tr>
											<tr>
												<td width="50%">County </td>
												<td width="50%">{state}</td>
											</tr>
											<tr>
												<td width="50%">Postcode  </td>
												<td width="50%">{postcode}</td>
											</tr>
										</tbody>
									</table>
									<h3>Account Details</h3>
									<table className="dashboard-table">
										<tbody>
											<tr>
												<td width="50%">Subscription </td>
												<td width="50%">{planName}</td>
											</tr>
											<tr>
												<td width="50%">Invoicing </td>
												<td width="50%">
													{billing === 'MONTHLY' ? 'Monthly' : 'Yearly'}
												</td>
											</tr>
											<tr>
												<td width="50%">Company email</td>
												<td width="50%">
													{this.props.allusers ? companyEmail : ''}
												</td>
											</tr>
											<tr>
												<td width="50%">Signup date</td>
												<td width="50%">
													{this.props.subscriptionhistory ?
														<Moment format="D MMM YYYY" >{trail_start_date}</Moment>
														: ''}
												</td>
											</tr>
											<tr>
												<td width="50%">Trial end date</td>
												<td width="50%">
													<div className="date-picker-icon">
														<MdDateRange />
														<DatePicker
															hintText="Trial end "
															// disabled={this.state.readonlydatepicker}
															container="inline"
															formatDate={(date) => moment(date).format('MMM-DD-YYYY')}
															onChange={this.trailEndDate}
															value={this.state.trailEndDate === null ? trailEndDate1 : this.state.trailEndDate}
															minDate={today}
														/>
													</div>
												</td>
											</tr>
											<tr>
												<td width="50%">Project allowance</td>
												<td width="50%">
													<TextField
														fullWidth={false}
														type="number"
														id="allowance"
														onChange={this.changeAllowance}
														errorText={this.state.allowanceError ? "Allowance can not be empty" : null}
														value={!this.state.allowanceUpdate && update_subs_data && update_subs_data[0] ? update_subs_data[0].allowance : this.state.allowance}
													/>
												</td>
											</tr>
											<tr>
												<td width="50%">
													<RaisedButton
														label="Update"
														type="button"
														labelColor="#fff"
														fullWidth={false}
														onClick={(e) => { this.updateDetail(id) }}
													/>
												</td>
											</tr>

										</tbody>
									</table>
								</div>
							</div>


							<div className="dashboard-table-data">
								<div className="audio-visual-list">
									<h3>simPRO Details</h3>
									{companyInfo &&
										<table className="dashboard-table">
											<tbody>
												<tr>
													<td width="50%">simPRO build</td>
													<td width="50%">
														{companyInfo.simpro_url || "N/A"}
														</td>
												</tr>
												<tr>
													<td width="50%">simPRO username</td>
													<td width="50%">
														{companyInfo.simprouser || "N/A"}
													</td>
												</tr>
												<tr>
													<td width="50%">simPRO password</td>
													<td width="50%">
														{companyInfo.simpropass || "N/A"}
													</td>
												</tr>
												<tr>
													<td width="50%">simPRO Force Re-authorise</td>
													<td width="50%">
														{companyInfo.simpropass && <Fragment>
															<RaisedButton
																label="Force Re-Authorise"
																type="button"
																labelColor="#fff"
																fullWidth={false}
																onClick={this._openForceAuthoriseModal}
															/>

															<Dialog
													          	title={`Are you sure you want to reauthorise forcefully?`}
													          	actions={[
													          		<FlatButton
																        label="Cancel"
																        primary={true}
																        onClick={this._closeForceAuthoriseModal}
																        keyboardFocused={true}
																        disabled={this.state.modalForceReAuthorise.requesting}
															      	/>,
															      	<RaisedButton
																        label={this.state.modalForceReAuthorise.requesting ? "Please! wait while processing..." : "Re-Authorise"}
																		labelStyle={{ 'color': '#fff' }}
																        primary={true}
																        onClick={(e) => {
																        	e.stopPropagation()
																        	this._doForceAuthorise()
																        }}
																        disabled={this.state.modalForceReAuthorise.requesting}
															      	/>
													          	]}
													          	modal={true}
													          	open={this.state.modalForceReAuthorise.isOpen}
													        >
													         	<table>
													         		<tbody>
													         			<tr>
																			<td width="50%">simPRO build</td>
																			<td width="50%">
																				{companyInfo.simpro_url || "N/A"}
																				</td>
																		</tr>
																		<tr>
																			<td width="50%">simPRO username</td>
																			<td width="50%">
																				{companyInfo.simprouser || "N/A"}
																			</td>
																		</tr>
																		<tr>
																			<td width="50%">simPRO password</td>
																			<td width="50%">
																				{companyInfo.simpropass || "N/A"}
																			</td>
																		</tr>
													         		</tbody>
													         	</table>
													        </Dialog>


															{/*<Dialog
																className="model-support"
																modal={false}
																open={this.state.isAuthoriseModalOpen}
																contentClassName="model-top-overlay no-overlay"
															>
																<Row>
																	<Col md={12}>
																		<div style={{ textAlign: 'center' }} >
																			<div className="progressbar1">
																				<LinearProgress mode="indeterminate" />
																			</div>
																			<p>Please! wait while processing...</p>
																		</div>
																	</Col>
																</Row>
															</Dialog>*/}
														</Fragment>}
													</td>
												</tr>

											</tbody>
										</table> }
								</div>
							</div>


							<div className="dashboard-table-data templete-page">
								<Row>
									<Col md={12}>
										<h3>Templates</h3>
										<PanelGroup
									        accordion
									        id="accordion-controlled-example"
									        activeKey={this.state.activeKey}
									      >
									        {groupedItems}
									        
									    </PanelGroup>
									</Col>
								</Row>
							</div>

							<div className="dashboard-table-data">
								<div className="">
									<Row className="display-flex padd30">
										<Col sm={6} xs={6} >
											<h3>Jobs</h3>
										</Col>
										<Col sm={3} className="hidden-xs"></Col>
										<Col sm={3} xs={6} className="text-right">
											<TextField
												fullWidth={true}
												floatingLabelText="Search..."
												type="text"
												onChange={this.jobSearchTextChange.bind(this,id)}
											/>
										</Col>
									</Row>
									<table className="dashboard-table responsive-table">
										<thead>
											<tr>
												<th>Job Id <a onClick={(e) => this.jobSortBy('jobid')}><i style={{ "padding": "5px" }} className="zmdi zmdi-unfold-more"></i></a></th>
												<th>Site <a onClick={(e) => this.jobSortBy('site')}><i style={{ "padding": "5px" }} className="zmdi zmdi-unfold-more"></i></a></th>
												<th>Status <a onClick={(e) => this.jobSortBy('status')}><i style={{ "padding": "5px" }} className="zmdi zmdi-unfold-more"></i></a></th>
												<th>Imported at <a onClick={(e) => this.jobSortBy('importedat')}><i style={{ "padding": "5px" }} className="zmdi zmdi-unfold-more"></i></a></th>
												<th>Sent to simPRO?</th>
												<th>Manual Created?</th>
											</tr>
										</thead>
										<tbody>
											{job}
										</tbody>

									</table>
									
								</div>
							<center>
								<Paginate props={this.props} handlePageChange={this.handlePageChange} itemsCountPerPage={10} totalItemsCount={this.props.allJobsCount ? this.props.allJobsCount :0} pageRangeDisplayed={8} activePage={this.state.activePage}/>
							</center>
							</div>
							<CancelDokkit 
								companyUserId = {companyUserId} 
								companyId = {id}
							/>							
							
						</div>

					</div>
				</div>
				<Dialog
					actions={action}
					className="model-support"
					modal={false}
					contentClassName="model-top-overlay no-overlay"
					open={this.state.modalIsOpenDeleteTemp}
					onRequestClose={this.closeModalDeleteTemp}
				>

					<div className="other-popup-content learn-more-popup">
						<form className="import-job-modal" >
							<h2 >Do you want to remove this manual type.?</h2>

						</form>
					</div>
				</Dialog>
				<Modal
					isOpen={this.state.modalIsOpen}
					onAfterOpen={this.afterOpenModal}
					onRequestClose={this.closeModal}
					style={customStyles}
					contentLabel="Template Upload Modal"
				>
					<form onSubmit={this.stopFormSubmit} className="upload-file-popup">
						<h2>{this.state.templatetitle}</h2>
						{isUploadingFile && <LinearProgress mode="indeterminate" />}
						<div className="display-flex">
							<label htmlFor="template-file" id="upload-file-template">
								<input
									id="template-file"
									type="file"
									name="template-file"
									onChange={this.registerFileToUpload}
									ref={(input) => { this.filesInput = input; }}
									accept="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
									disabled={isUploadingFile}
								/>
								Choose File
                            </label>
							<div id="upload-text">
								{this.state.uploadFiles ? this.state.uploadFiles[0].name : 'No file chosen...'}
							</div>
						</div>
						<div>
							<Row>
								<Col md={6}>
									<RaisedButton
										label={uploadLabel}
										type="submit"
										labelColor="#fff"
										fullWidth={true}
										onClick={(e) => { this.uploadTemplateFile(id, manual_id, template_id) }}
										disabled={isUploadingFile}
									/>
								</Col>
								<Col md={6}>
									<RaisedButton
										label="Cancel"
										type="submit"
										labelColor="#fff"
										fullWidth={true}
										onClick={this.closeModal}
										disabled={isUploadingFile}
									/>
								</Col>
							</Row>
						</div>
					</form>
				</Modal>
			</div>
		)
	}
}
const mapStateToProps = (state, props) => {
	console.log("state.login=====>",state.login)
	return {
		companydetails: state.login.companydetail,
		subsusers: state.login.subsuser,
		subscriptions: state.login.subscriptions,
		alljobs: state.login.alljobs,
		companyjobs: state.login.companyjobs,
		templates: state.templates,
		subsusers: state.login.subsuser,
		companies: state.login.company,
		manuals: state.manuals,
		adminData: state.login.adminData,
		subscriptionhistory: state.login.subscriptionhistory,
		subscriptionsReducer: state.subscription,
		allusers: state.login.allusers,
		companyTemplateSet : state.company.companyTemplateSet,
		allJobsCount:state.login.allJobsCount
	};
}

AdminCompany = withRouter(connect(
	mapStateToProps,
	actions
)(AdminCompany));

export default AdminCompany;


// WEBPACK FOOTER //
// ./src/Components/Pages/Admin/AdminCompany.js